<template>
  <div class="spliter">
    <div class="ly-title">
      <h2 class="title">
        메세지 수신그룹 관리
        <el-button
          size="mini"
          plain
          type="primary"
          class="title-dims"
          @click="$EventBus.$emit('dimsInquiry')"
          >DIMS 문의</el-button
        >
      </h2>
      <idc-breadcrumb :breadcrumbList="breadcrumbList" />
    </div>
    <div class="spliter-con">
      <multipane
        class="custom-resizer"
        layout="vertical"
        @paneResize="paneResize"
        @paneResizeStop="paneresizeStop"
      >
        <msg-group-manage-menu ref="menu" selectPopup />
        <multipane-resizer />
        <msg-group-manage-list ref="list" @selectMsgGroup="selectMsgGroup" />
        <multipane-resizer />
        <msg-group-manage-detail
          @expandDetailView="expandDetailView"
          selectPopup
          ref="detail"
        />
      </multipane>
    </div>
    <div class="dialog-footer align-r">
      <el-button type="info" @click="closeSelectMsgGroupModal">{{
        $t("messages.btnCancel")
      }}</el-button>
      <el-button type="primary" @click="getMsgGroup">{{
        $t("messages.plSelectOp")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import IdcBreadcrumb from "@/components/common/IdcBreadcrumb";
import { Multipane, MultipaneResizer } from "vue-multipane";
import MsgGroupManageMenu from "@/components/serviceComponents/MsgGroupManageMenu.vue";
import MsgGroupManageList from "@/components/serviceComponents/MsgGroupManageList.vue";
import MsgGroupManageDetail from "@/components/serviceComponents/MsgGroupManageDetail.vue";
export default {
  mixins: [commonMixin],
  components: {
    IdcBreadcrumb,
    Multipane,
    MultipaneResizer,
    MsgGroupManageMenu,
    MsgGroupManageList,
    MsgGroupManageDetail,
  },
  computed: {
    breadcrumbList() {
      return this.$route.meta.navigator;
    },
    open() {
      return this.$store.getters["popupManageStore/getModalSelectMsgGroup"];
    },
  },
  watch: {
    open(newValue) {
      // init list, detail
      if (newValue) {
        this.msgGroup = {};
        this.$refs.list.initSelectList();
      }
    },
  },
  data() {
    return {
      msgGroup: {},
    };
  },
  methods: {
    selectMsgGroup(row) {
      this.msgGroup = row;
    },
    closeSelectMsgGroupModal() {
      this.$store.commit("popupManageStore/setModalSelectMsgGroup", false);
    },
    getMsgGroup() {
      if (Object.keys(this.msgGroup).length === 0) {
        alert("메세지 수신 그룹을 선택하세요.");
        return;
      }
      this.$emit("getMsgGroup", this.msgGroup, this.$refs.detail.subData);
      this.closeSelectMsgGroupModal();
    },
    expandDetailView() {
      this.$refs.menu.onComponentDetailView();
      this.$refs.list.onComponentDetailView();
    },
  },
};
</script>

<style lang="scss" scoped>
.select-popup {
  height: 300px;
}
.align-button-input {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
::v-deep {
  .el-table__body-wrapper {
    overflow: auto;
    height: calc(100vh - 370px);
  }
  .title-sub-in-tab {
    color: $--color-black;
    font: {
      size: $--font-size-medium;
      weight: $--font-weight-bold;
    }
  }
  .input-btn {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 5px;
    margin-top: 3px;
    &-table {
      margin-top: 0;
    }
  }
  .el-form-item__label {
    line-height: 40px;
  }
  .el-dialog .modal-row {
    padding-bottom: 12px;
    &:first-child {
      padding-bottom: 5px;
    }
  }
  .modal-input-box-upload .el-form-item__content {
    padding-top: 6px;
  }
}
.ly-detail-footer {
  justify-content: space-between;
}
.ly {
  &-detail {
    &-wrap {
      overflow-y: hidden;
    }
    &-content {
      //220614 버튼이 상단인 경우
      height: calc(100% - 10px);
      min-height: calc(100% - 10px);

      //220614 버튼이 하단인 경우
      // height: calc(100% - 120px);
      // min-height: calc(100% - 120px);

      .el-tab-pane {
        height: calc(100% - 20px);
        .tab-table {
          // height: 100%;
        }
      }
      .el-tabs {
        height: 100%;
        ::v-deep {
          .el-tabs__content {
            // margin-top: -10px;
            overflow-y: auto;
            // height: calc(100% - 44px);
            &::-webkit-scrollbar {
              width: 8px;
              height: 8px;
              &-thumb {
                width: 3px;
                height: 3px;
                background-color: $--text-disabled;
                border-radius: $--border-radius-base;
              }
            }
          }
        }
      }
    }
  }
}
.table-flex li {
  line-height: 16px;
}
::v-deep {
  @include mobile {
    .el-form-item__label {
      width: 120px !important;
    }
    .el-dialog {
      width: calc(100% - 60px) !important;
      min-width: 300px;
      position: fixed;
      margin: 0 !important;
      width: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      &__header {
        padding-bottom: 10px;
      }
    }
    .el-dialog-mobile {
      .el-dialog {
        &__header {
          padding-bottom: 0;
          border-bottom: none;
        }
        &__headerbtn {
          display: none;
        }
        &__body {
          padding: 20px 0 0;
        }
      }
    }
    .el-form {
      border-top: $--border-color-gray;
      padding-bottom: 20px;
      .el-row {
        padding-bottom: 0;
      }
      &-item {
        border-bottom: $--border-color-gray;
        &__label {
          background-color: $--color-white-smoke;
          border-right: $--border-color-gray;
          padding-left: 10px;
        }
      }
    }
    .desc {
      &-tit {
        color: $--text-nodata;
        padding-bottom: 10px;
      }
      &-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        line-height: 1.5;
        &:not(:first-child) {
          margin-top: 10px;
        }
        &-tit {
          color: $--text-nodata;
          flex: 0 0 65px;
        }
        &-txt {
          flex: 0 0 calc(100% - 65px);
          div {
            display: block;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
